"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/geo/index.ts
var regionIdByTLD = {
  by: 149,
  co: 225,
  // odna.co
  com: 1e4,
  // earth
  kz: 159,
  ru: 225,
  "com.tr": 983
};
var getRegionIdByTLD = (tld) => regionIdByTLD[tld];
var getTLDFromHost = (host) => {
  var _a;
  let tld;
  if (host.includes(".yandex.")) {
    tld = (_a = host.split(".yandex.").slice(-1)[0]) != null ? _a : "ru";
  } else {
    tld = host.split(".").slice(-1)[0];
  }
  return regionIdByTLD[tld] ? tld : "ru";
};




exports.getRegionIdByTLD = getRegionIdByTLD; exports.getTLDFromHost = getTLDFromHost;
//# sourceMappingURL=chunk-BYIEAVCX.js.map